import React, { useCallback, useMemo } from 'react';
import { Grid } from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import { useTracker } from '@dpdgroupuk/react-event-tracker';

import ActionButtons from '../Buttons/ActionButtons';

const ActionsSnackbar = ({
  onConfirm,
  onClose,
  confirmActionId,
  cancelActionId,
  onConfirmText,
  onCloseText,
  ...params
}) => {
  const tracker = useTracker();
  const clickConfirm = useCallback(() => {
    confirmActionId && tracker.logEvent(confirmActionId);
    onConfirm && onConfirm();
  }, [confirmActionId, onConfirm, tracker]);

  const clickClose = useCallback(() => {
    cancelActionId && tracker.logEvent(cancelActionId);
    onClose && onClose();
  }, [cancelActionId, onClose, tracker]);

  const message = useMemo(
    () =>
      Array.isArray(params.message) ? (
        <Grid container direction="column">
          {params.message.map((message, idx) => (
            <span key={`${idx}`}>{message}</span>
          ))}
        </Grid>
      ) : (
        params.message
      ),
    [params.message]
  );

  return (
    <SnackbarContent
      {...params}
      message={message}
      action={
        <ActionButtons
          onConfirm={clickConfirm}
          onClose={clickClose}
          onConfirmText={onConfirmText}
          onCloseText={onCloseText}
        />
      }
    />
  );
};

export default ActionsSnackbar;
